'use client';

import Link from '@eliadmin/core/src/components/link';

import type { ImagesEntityOrAttachmentsEntityOrImage } from '@eliadmin/core/src/api/products/types/product-types';

import { ProductTabContainer } from './product-tab-container';
import { LuDownload } from 'react-icons/lu';

export function ProductTabAttachments({
  attachments,
  title,
}: {
  attachments: ImagesEntityOrAttachmentsEntityOrImage[];
  title: string;
}) {
  return (
    <ProductTabContainer title={title} className="w-full">
      <ul className="flex w-full flex-col items-start justify-start gap-4">
        {attachments.map(attachment => (
          <li key={attachment.url} className="w-full">
            <Link
              prefetch={false}
              href={attachment.url}
              target="_blank"
              className="flex w-full items-center justify-between rounded-full bg-input px-6 py-4 transition-all hover:bg-input/80"
            >
              <p className="text-sm font-medium xl:text-base">{attachment.name}</p>
              <LuDownload size={20} className="text-primary" />
            </Link>
          </li>
        ))}
      </ul>
    </ProductTabContainer>
  );
}
